import './Core.css';
import { Link } from "react-router-dom";
import imageBackgroundWhiteGraphicsSquareLeft from './../../images/background_white_graphics_square_left_01.png';
import imageBackgroundWhiteGraphicsSquareRight from './../../images/background_white_graphics_square_right_01.png';

const Core = () => {
  return (
    <div className="core">
      <header className="sectionLanding">
        <div className="sectionLandingBackgroundLeft"><img src={imageBackgroundWhiteGraphicsSquareLeft} /></div>
        <div className="sectionLandingBackgroundRight"><img src={imageBackgroundWhiteGraphicsSquareRight} /></div>
        <div className="sectionLandingContentWrapper">
          <div className="sectionLandingLeft">
            <h1>
              Welcome
            </h1>
          </div>
        </div>
      </header>
      <div className="sectionSeparator default"></div>
      <div className="sectionLanding">
        <div className="sectionLandingContentWrapper">
          <div className="sectionLandingLeft">
            <img src="https://idlepetparadise.com/wp-content/uploads/2021/11/Idle_Pet_Paradise_iPhone_Mockup_02_500x648.png"/>
            <div className="appStoreLinks">
              <a href="https://apps.apple.com/app/apple-store/id1590186647?pt=207581&ct=MagmicCore&mt=8" target={"_blank"}><img src="./images/app_stores/apple.png" /></a>
              <a href="https://play.google.com/store/apps/details?id=com.magmic.android.IdlePetParadise" target={"_blank"}><img src="./images/app_stores/google.png" /></a>
            </div>
          </div>
          <div className="sectionLandingRight">
            <p align="center"><img alt="Idle Pet Paradise" src="https://idlepetparadise.com/wp-content/uploads/2021/11/Idle_Pet_Paradise_Logo_628x540.png" style={{width: "350px", maxWidth: "100%"}} /></p>
            <h2>
              <p>
                Download the game and connect your account to Magmic Core to get full access to the NFT marketplace.
              </p>
            </h2>
            <div className="actions">
              <a href="https://idlepetparadise.com/" target="_blank">Idle Pet Paradise Website</a>
            </div>
          </div>
        </div>
      </div>
      <div className="sectionLanding">
        <div className="sectionLandingContentWrapper">
        <div className="sectionLandingLeft">
            <h1>
              NFTs
            </h1>
            <h2>
              <p>
                Buy featured and exclusive NFTs in the <Link to='/nfts'>FEATURED</Link> content.
              </p>
              <p>
                Buy and sell NFTs with other players in the <Link to='/marketplace'>NFT MARKETPLACE</Link>.
              </p>
              <dl><dd>You must create a Magic Core account and link it to your Idle Pet Paradise account before you can purchase NFTs.</dd></dl>
              <p>
                Purchase Magmic Coin from the Exchange.
              </p>
              <dl><dd>You must link your Idle Pet Paradise account to the Forte Exchange in order to purchase Magmic Coin.</dd></dl>
            </h2>
          </div>
          <div className="sectionLandingRight">
            <div className="actions stretchToFit">
              <Link to='/nfts'>FEATURED NFTs</Link>
              <Link to='/marketplace'>NFT MARKETPLACE</Link>
              <Link to='/wallet'>BUY COINS</Link>
            </div>
          </div>
        </div>
      </div>
      <section className="coreSection">
      </section>
    </div>
  );
}

export default Core;